import { createFileRoute } from '@tanstack/react-router';
import { S6SensorDetail } from '@/screens/S6SensorDetail/S6SensorDetail';
import { useApiClients } from '@/app/ApiProvider';

export const Route = createFileRoute('/$orgId/sensors/$id')({
  component: SensorScreen,
});

function SensorScreen() {
  const { id } = Route.useParams();
  const clients = useApiClients();
  return <S6SensorDetail clients={clients} sensorId={id} />;
}
